/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Global styles needed for ProseMirror decoration classes
import { css, Global, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

const remixHoverHighlightBackground = token('color.background.accent.blue.subtler');
const remixHoverHighlightBorder = token('color.background.accent.blue.subtler');

const persistedHighlightStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- ProseMirror decoration class
	'.akEditor div.ProseMirror .remix-thinking-highlight': {
		backgroundColor: token('color.background.accent.purple.subtlest'),
		textDecoration: 'underline',
		textDecorationStyle: 'dotted',
		textDecorationThickness: token('space.025'),
		textDecorationColor: token('color.border.accent.purple'),
		textDecorationSkipInk: 'none',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Default remix hover highlight for non-table nodes
	'.akEditor div.ProseMirror .remix-hover-highlight': {
		background: remixHoverHighlightBackground,
		boxShadow: `0 0 0 2px ${remixHoverHighlightBorder}`,
	},
});

export const PersistedSelectionHighlightStyles = (): React.ReactElement => {
	return (
		<React.Fragment>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Global ProseMirror decoration styles */}
			<Global styles={persistedHighlightStyles} />
		</React.Fragment>
	);
};
